export default class Autocomplete {

  constructor(input, data, container, handleSubmit, handleValidated) {
    this.input = input;
    this.data = data;
    this.container = container;
    this.handleSubmit = (lineageName)=>{
      this.close();
      handleSubmit(lineageName);
    };
    this.handleValidated = handleValidated;
    input.addEventListener("input", event=>this.handleInput(event));
    input.addEventListener("keydown", event=>this.handleKeyDown(event));
    container.addEventListener("input", event=>this.handleInput(event));
    container.addEventListener("keydown", event=>this.handleKeyDown(event));
    container.addEventListener("mousedown", event=>this.handleMousedown(event));
    container.addEventListener("mousemove", event=>this.handleMousemove(event));
    container.addEventListener("mouseleave", event=>this.handleMouseleave(event));


  }


  handleInput(event) {
    event.stopPropagation();
    let query = this.input.value.toLowerCase(),
      text = '',
      count = 0;
    this.index = -1;
    this.data.forEach(d=>{
      if (d.toLowerCase().indexOf(query) >= 0) {
        text += `<div class="ac-result">${d}</div>\n`;
        count++;
      }
    });
    this.container.innerHTML = text;
    this.container.style.display = 'block';
    this.resultCount = count;
    this.handleValidated();
  }


  handleKeyDown(event) {
    event.stopPropagation();
    if (event.key === "ArrowDown") {
      //
    } else if (event.key === "ArrowUp") {
      //
    } else if (event.key === "Enter") {
      this.handleSubmit(this.input.value);
    } else if (event.key === "Escape") {
      this.close();
    }
  }


  handleMousedown(event) {
    let target = this.getMouseTarget(event);
    while (target && target !== this.container && !target.classList.contains("ac-result")) {
      target = target.parentNode;
    }
    if (target && target !== this.container) {
      let val = target.innerText;
      this.input.value = val;
      this.handleSubmit(val);
    }
  }


  handleMousemove(event) {
    let target = this.getMouseTarget(event);
    this.container.querySelectorAll('.highlight').forEach(div=>div.classList.remove('highlight'));
    target.classList.add('highlight');
  }


  handleMouseleave() {
    this.container.querySelectorAll('.highlight').forEach(div=>div.classList.remove('highlight'));
  }

  getMouseTarget(event) {
    let target = event.target;
    while (target.nodeName !== "DIV") {
      target = target.parentNode;
    }
    return target;
  }

  close() {
    this.input.blur();
    this.container.style.display = 'none';
    this.container.innerHTML = '';
    this.input.value = "";
  }

}

